"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var icon_1 = require("../icon");
var classnames_1 = require("classnames");
exports.default = (function (_a) {
    var theme = _a.theme, message = _a.message, backgroundColor = _a.backgroundColor, borderColor = _a.borderColor, className = _a.className, _b = _a.title, title = _b === void 0 ? "WARNING!" : _b, _c = _a.iconName, iconName = _c === void 0 ? "icon-warning" : _c, _d = _a.color, color = _d === void 0 ? "var(--panel-message-text-color)" : _d, others = tslib_1.__rest(_a, ["theme", "message", "backgroundColor", "borderColor", "className", "title", "iconName", "color"]);
    return (React.createElement("div", { className: classnames_1.default(theme.panel, className), style: { backgroundColor: backgroundColor, color: color, borderColor: borderColor } },
        React.createElement("div", { className: theme.icon },
            React.createElement(icon_1.Icon, { iconName: iconName, size: 1.8, iconColor: color })),
        React.createElement("strong", { style: { marginRight: 10, letterSpacing: 1, textTransform: "uppercase" } }, title),
        message));
});
